import { render, staticRenderFns } from "./AccrualsDataWorkspace.vue?vue&type=template&id=2c885366&scoped=true"
import script from "./AccrualsDataWorkspace.vue?vue&type=script&lang=js"
export * from "./AccrualsDataWorkspace.vue?vue&type=script&lang=js"
import style0 from "./AccrualsDataWorkspace.vue?vue&type=style&index=0&id=2c885366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c885366",
  null
  
)

export default component.exports